//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { envConfig } from '@/js/constants';
import tasks from '@/js/tasks';
var pagitation = new tasks.PaginationHelpNew();
export default {
  name: 'PaginationSearching',
  props: {
    queryObject: {
      type: Object,
      default: null
    },
    reloadMethod: {
      type: Function,
      default: null
    },
    isNewQuery: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      historyPageToken: {
        index: 0,
        list: [null]
      },
      showPrev: true,
      showNext: true,
      PAGE_SIZE: envConfig.pagintaionSize,
      queryResponse: {},
      disabled: false
    };
  },
  computed: {
    hasToken: function hasToken() {
      var _ref = this.queryObject || {},
        _ref$next_page_token = _ref.next_page_token,
        next_page_token = _ref$next_page_token === void 0 ? {} : _ref$next_page_token;
      return Object.values(next_page_token).length > 0;
    }
  },
  watch: {
    'queryObject': function queryObject(val) {
      this.queryResponse = val;
    },
    'isNewQuery': function isNewQuery(val) {
      if (val) {
        this.historyPageToken = {
          index: 0,
          list: [null]
        };
      }
    }
  },
  created: function created() {
    pagitation.set(this);
    this.queryResponse = this.queryObject;
  },
  methods: {
    goFirst: function goFirst() {
      pagitation.first(this);
    },
    goPrev: function goPrev() {
      pagitation.back(this);
    },
    goNext: function goNext() {
      pagitation.next(this);
    }
  }
};